/* SERENIL - cloned sections helper: CTA scroll-to-buybox + evergreen countdown */
(function(){
  "use strict";

  function findBuyBox(){
    var sels = [
      "#serenil-buybox",
      ".quantity-break",
      "quantity-break",
      ".product-form__quantity",
      ".product-form__buttons",
      ".product-form",
      "product-form",
      "#MainProduct .price",
      "#MainProduct",
      ".shopify-section .product-form"
    ];
    for (var i=0;i<sels.length;i++){
      var el=document.querySelector(sels[i]);
      if(el) return el;
    }
    // fallback: the main-product section wrapper
    return document.querySelector('[id^="shopify-section"] .product, main') || null;
  }

  function headerOffset(){
    var h=document.querySelector('.section-header, header, .header-wrapper, sticky-header, #shopify-section-header');
    var hh = h ? h.getBoundingClientRect().height : 0;
    if(!hh || hh>200) hh=90;              // sticky header reports huge height -> clamp
    return hh+12;
  }

  function scrollToBuyBox(){
    var el=findBuyBox();
    if(!el) return;
    var y=el.getBoundingClientRect().top + window.pageYOffset - headerOffset();
    window.scrollTo({top:y, behavior:"smooth"});
  }

  function bind(root){
    var btns=(root||document).querySelectorAll('.srl [data-srl-scroll], .srl .btn-cta');
    btns.forEach(function(b){
      if(b.__srlBound) return; b.__srlBound=true;
      b.addEventListener('click', function(e){ e.preventDefault(); scrollToBuyBox(); });
    });
  }

  /* evergreen countdown: any .srl [data-srl-countdown] block holding .num cells */
  function startCountdown(box){
    if(box.__srlCd) return; box.__srlCd=true;
    var KEY="srl_cd_end";
    var hrs=parseInt(box.getAttribute('data-srl-hours')||"4",10);
    var end=parseInt(localStorage.getItem(KEY)||"0",10);
    var now=Date.now();
    if(!end || end<now) { end=now+hrs*3600*1000; try{localStorage.setItem(KEY,String(end));}catch(e){} }
    var h=box.querySelector('[data-cd="h"]'), m=box.querySelector('[data-cd="m"]'), s=box.querySelector('[data-cd="s"]');
    function pad(n){return (n<10?"0":"")+n;}
    function tick(){
      var d=Math.max(0,Math.floor((end-Date.now())/1000));
      if(h)h.textContent=pad(Math.floor(d/3600));
      if(m)m.textContent=pad(Math.floor((d%3600)/60));
      if(s)s.textContent=pad(d%60);
      if(d<=0){ end=Date.now()+hrs*3600*1000; try{localStorage.setItem(KEY,String(end));}catch(e){} }
    }
    tick(); setInterval(tick,1000);
  }

  function init(){
    bind(document);
    document.querySelectorAll('.srl [data-srl-countdown]').forEach(startCountdown);
  }
  if(document.readyState!=="loading") init();
  else document.addEventListener("DOMContentLoaded", init);
  // Shopify theme editor re-render
  document.addEventListener("shopify:section:load", function(e){ bind(e.target); e.target.querySelectorAll('.srl [data-srl-countdown]').forEach(startCountdown); });
})();
